import React from 'react'

import Component from './component'

const Container = ({ voucher_id }) => {
  const mergedProps = {
    voucher_id
  }

  return (
    <Component {...mergedProps} />
  )
}

export default Container
